import { Button, Stack, Typography } from '@common-components';
import { useCurrentUser } from 'hooks';
import { messages } from 'i18n';
import { BROKER_NESTED_ROUTES } from 'broker/broker-routes';
import { RouteKey } from 'broker/enums';
import { useNavigate } from 'broker/hooks';

interface MarketsHeaderProps {
  teamName: string;
  onOpenDialog: () => void;
}

export default function MarketsHeader({ teamName, onOpenDialog }: MarketsHeaderProps) {
  const { me } = useCurrentUser();
  const navigate = useNavigate();
  const isDirectPlacementUser = !!me?.endUser?.isDirectPlacement;

  const organizationId = me?.endUser?.organization.id;
  const organizationName = me?.endUser?.organization.name;

  const addAgent = () => {
    if (!organizationId || !organizationName) {
      return;
    }
    navigate(
      {
        pathname: BROKER_NESTED_ROUTES.TEAM.AGENT,
      },
      {
        routeKey: RouteKey.Agent,
        state: { organizationId, organizationName },
      },
    );
  };

  const actionButton = isDirectPlacementUser ? (
    <Button variant="contained" onClick={addAgent}>
      {messages.myTeamPage.addAgent}
    </Button>
  ) : (
    <Button variant="contained" onClick={onOpenDialog}>
      {messages.myTeamPage.InviteButton}
    </Button>
  );

  return (
    <Stack justifyContent="space-between" direction="row">
      <Stack direction="column">
        <Typography variant="h4">{teamName}</Typography>
      </Stack>
      <Stack>{actionButton}</Stack>
    </Stack>
  );
}
